import { Radio, RadioGroupProps } from 'antd'

import { TriState } from 'src/api/requests'
import { useLocales } from 'src/locales'

import { ReadOnlyChoice, useIsReadOnlyForm } from './ReadOnly'

const options = [TriState.YES, TriState.NO, TriState.UNKNOWN]
const yesNoOptions = [TriState.YES, TriState.NO]

type Props = RadioGroupProps & {
  /** Only Da / Nu, for the questions without "?" on the form (54, 55, 57–59). */
  yesNoOnly?: boolean
}

/** A Da / Nu / ? answer of Form 058-1/e. "?" is an answer; an empty value is not. */
export const TriStateRadio = ({ yesNoOnly = false, ...props }: Props) => {
  const { t } = useLocales()
  const isReadOnly = useIsReadOnlyForm()

  if (isReadOnly) {
    return (
      <ReadOnlyChoice
        label={
          props.value ? t(`hiv_anamnesis.tri_state.${props.value}`) : undefined
        }
      />
    )
  }

  return (
    <Radio.Group {...props}>
      {(yesNoOnly ? yesNoOptions : options).map((option) => (
        <Radio key={option} value={option}>
          {t(`hiv_anamnesis.tri_state.${option}`)}
        </Radio>
      ))}
    </Radio.Group>
  )
}
